import { api } from "@/config/api";
import type { AxiosError } from "axios";
import { CheckoutFailReason } from "ipctg-inflow-types/InFlowEnums";
import type { ParkPaymentIntentPOSTErrorResponse, ParkPaymentIntentPOSTRequest, ParkPaymentIntentPOSTSuccessResponse } from "ipctg-inflow-types/InFlowParkAPI";

export const getPaymentIntent = async (requestData: ParkPaymentIntentPOSTRequest): Promise<ParkPaymentIntentPOSTSuccessResponse> => {
  try {
    const response = await api.post<ParkPaymentIntentPOSTSuccessResponse>("/payment-intent", requestData);
    return response.data;
  } catch (error) {
    const axiosError = error as AxiosError<ParkPaymentIntentPOSTErrorResponse>;
    throw axiosError.response?.data ?? { failReason: CheckoutFailReason };
  }
};
